import { render, staticRenderFns } from "./BioBreakClassroomError.vue?vue&type=template&id=c0365a9c&"
import script from "./BioBreakClassroomError.vue?vue&type=script&lang=js&"
export * from "./BioBreakClassroomError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports